import { list } from '../favourites/tags';

function endpoints(builder) {
  return {
    loginCollectorUser: builder.mutation({
      invalidatesTags: (result, error) => (error ? [] : list),
      query: (values) => {
        const body = new FormData();
        if (values.csrfParam && values.csrfToken) {
          body.append(values.csrfParam, values.csrfToken);
        }
        body.append('action', 'users/login');
        body.append('loginName', (values.email || ''));
        body.append('password', (values.password || ''));
        body.append('rememberMe', (values.rememberMe && values.rememberMe.length > 0 ? '1' : '0'));

        return {
          url: '/',
          method: 'POST',
          body,
        };
      },
    }),
    sendPasswordResetEmailCollectorUser: builder.mutation({
      query: (values) => {
        const body = new FormData();
        if (values.csrfParam && values.csrfToken) {
          body.append(values.csrfParam, values.csrfToken);
        }
        body.append('action', 'tefaf/collectorportal/user/send-password-reset-email');
        body.append('collectingGuideId', (values.collectingGuideId || ''));
        body.append('email', (values.email || ''));

        return {
          url: '/',
          method: 'POST',
          body,
        };
      },
    }),
    setPasswordCollectorUser: builder.mutation({
      query: (values) => {
        const body = new FormData();
        if (values.csrfParam && values.csrfToken) {
          body.append(values.csrfParam, values.csrfToken);
        }
        body.append('action', 'users/set-password');
        body.append('code', (values.code || ''));
        body.append('id', (values.id || ''));
        body.append('newPassword', (values.password || ''));

        return {
          url: '/',
          method: 'POST',
          body,
        };
      },
    }),
  };
}

export { endpoints };
